import { JourneysLegacyRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/account_canceled/$')({
  component: JourneysLegacyRoute,
});
